module.exports = __webpack_public_path__ + "static/media/noa_kit_front.625a973f.png";